package com.neurobs.ccabserver.administrator.components

import com.neurobs.ccab.CCABServer
import com.neurobs.ccab.db.StudyData
import com.neurobs.ccabserver.administrator.contexts.UserContext
import com.neurobs.errors.Result
import com.neurobs.react.{CardContentProvider, Link, CardDeck, Table, TableCell, TableHeader, TableRow}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.web.html.{div, key}

import scala.concurrent.Future

@react object ResultsStudyList {
	case class Props
	(
		accountId: Long,
		studies: Seq[StudyData],
		delegate: CardContentProvider.Delegate,
		dataPassword: String
	)
	val component = FunctionalComponent[Props] { props =>
		Table(
			TableHeader(
				TableCell("Study"), TableCell("Description")
			),
			props.studies map { s =>
				val link = Link(
					caption = s.displayName,
					onClick = () => {
						props.delegate.addCard(
							card = new ResultsSubjectListProvider(accountId = props.accountId, studyId = s.id, studyName = s.displayName, dataPassword = props.dataPassword),
							afterThis = true
						)
					}
				)
				TableRow(
					TableCell(link),
					TableCell(s.description)
				).withKey(key = s.id.toString)
			}
		)
	}
}

class ResultsStudyListCardProvider(accountId: Long, dataPassword: String) extends CardContentProvider {
	override def title: String = "Result Studies"

	override def canClose: Boolean = false

	override def refreshFunction: Option[CCABServer => Future[Result[AnyRef]]] = Some { server =>
		server.getStudies(accountId = accountId)._2
	}

	override def content(d: CardContentProvider.Delegate, contentData: Option[AnyRef]): ReactElement = {
		ResultsStudyList(accountId = accountId, studies = contentData.get.asInstanceOf[Seq[StudyData]], delegate = d, dataPassword = dataPassword)
	}
}

@react object ResultsStudyListContainer {
	type Props = Unit
	val component = FunctionalComponent[Props] { _ =>
		val user = UserContext.accessState()

		RequireDataPassword { dataPassword =>
			CardDeck.View(defaultCard = new ResultsStudyListCardProvider(accountId = user.user.get.legacyAccountId, dataPassword = dataPassword))
		}
	}
}